export default __webpack_public_path__ + "static/logo-21b580773d9a1db6bfb83c3f4cc766d0.png";